import { DEFAULT_TIMEOUT, DEFAULT_WARNING_TIMEOUT } from 'utility/constants';
import { PanelPresets } from '../../utility/enumerations';
import {
  ADD_MESSAGE,
  CLEAR_MESSAGES,
  CLEAR_MODAL,
  END_WAIT,
  REMOVE_MESSAGE,
  RENDER_MODAL,
  RESET_STATE,
  SET_DEBUG_OVERLAY_ENABLED,
  SET_PANEL_DISPLAY,
  SET_SERVER_ALIAS,
  SET_SERVER_VERSION,
  WAIT,
  SET_PRIMARY_PANEL_VIEW,
  SET_SECONDARY_PANEL_VIEW,
  CLEAR_SECONDARY_PANEL,
  CLEAR_PRIMARY_PANEL,
  Message,
  PayloadAction,
  SET_SESSION_TIMEOUT,
  SET_SESSION_WARNING_TIMEOUT,
  WAPI_REFETCH,
  SET_POSTLOGIN_SCREEN_ROUTE
} from '../types/global';

export interface GlobalState {
  waiting: boolean,
  modal: any,
  messages: Message[],
  serverVersion: string,
  serverAlias: string,
  panelDisplayStates: number,
  debugOverlayEnabled: boolean,
  primaryPanelView: any,
  secondaryPanelView: any,
  sessionTimeoutInSeconds: any,
  sessionWarningTimeoutInSeconds: any,
  wapiRefetch: boolean,
  postLoginScreenRoute: string
}

const INITIAL_STATE: GlobalState = {
  waiting: false,
  modal: null,
  messages: [],
  serverVersion: null,
  serverAlias: null,
  panelDisplayStates: PanelPresets.OneFull,
  debugOverlayEnabled: false,
  primaryPanelView: {
    viewPath: 'public/home',
    viewProps: {},
    focusView: false,
    overrideLocation: '',
    params: {}
  },
  secondaryPanelView: {},
  sessionTimeoutInSeconds: DEFAULT_TIMEOUT,
  sessionWarningTimeoutInSeconds: DEFAULT_WARNING_TIMEOUT,
  wapiRefetch: false, // to track everytime the API is called, used by session timeout
  postLoginScreenRoute: '/'
};

function globalReducer(state: GlobalState = INITIAL_STATE, action: PayloadAction<any>): GlobalState {
  switch (action.type) {
    case RESET_STATE:
      return { ...INITIAL_STATE, primaryPanelView: { ...state.primaryPanelView, viewPath: 'security/login' } }; // resets everything and send to login screen (for logouts)
    case WAIT:
      return { ...state, waiting: true };
    case END_WAIT:
      return { ...state, waiting: false };
    case RENDER_MODAL:
      return { ...state, modal: action.payload };
    case CLEAR_MODAL:
      return { ...state, modal: null };
    case ADD_MESSAGE:
      return { ...state, messages: [...state.messages, action.payload] };
    case WAPI_REFETCH:
      return { ...state, wapiRefetch: !state.wapiRefetch };
    case REMOVE_MESSAGE:
      const newmessages = state.messages.filter((message) => message.id !== action.payload);
      return { ...state, messages: newmessages };
    case CLEAR_MESSAGES:
      return { ...state, messages: [] };
    case SET_SERVER_ALIAS:
      return { ...state, serverAlias: action.payload };
    case SET_SERVER_VERSION:
      return { ...state, serverVersion: action.payload };
    case SET_PANEL_DISPLAY:
      return { ...state, panelDisplayStates: action.payload };
    case SET_DEBUG_OVERLAY_ENABLED:
      return { ...state, debugOverlayEnabled: action.payload };
    case SET_PRIMARY_PANEL_VIEW:
      if (JSON.stringify(state.primaryPanelView) === JSON.stringify(action.payload)) {
        return state;
      }
      return {
        ...state,
        primaryPanelView: action.payload,
      };
    case SET_SECONDARY_PANEL_VIEW:
      if (JSON.stringify(state.secondaryPanelView) === JSON.stringify(action.payload)) {
        return state;
      }
      return {
        ...state,
        secondaryPanelView: action.payload,
      };
    case CLEAR_PRIMARY_PANEL:
      if (JSON.stringify(state.primaryPanelView) === '{}') {
        return state;
      }
      return {
        ...state,
        primaryPanelView: {},
      };
    case CLEAR_SECONDARY_PANEL:
      if (JSON.stringify(state.secondaryPanelView) === '{}') {
        return state;
      }
      return {
        ...state,
        secondaryPanelView: {},
      };
    case SET_SESSION_TIMEOUT:
      return {
        ...state,
        sessionTimeoutInSeconds: action.payload
      };
    case SET_SESSION_WARNING_TIMEOUT:
      return {
        ...state,
        sessionWarningTimeoutInSeconds: action.payload
      };
    case SET_POSTLOGIN_SCREEN_ROUTE:
      return {
        ...state,
        postLoginScreenRoute: action.payload
      };
    default:
      return state;
  }
}

export default globalReducer;
